import DOMPurify from "dompurify";

function setInnerHTML(el, binding) {
  const value = binding.value;
  el.innerHTML = DOMPurify.sanitize(value == null ? "" : String(value));
}

export default {
  install(Vue) {
    Vue.directive("dompurify-html", {
      inserted: setInnerHTML,
      update(el, binding) {
        if (binding.value === binding.oldValue) return;
        setInnerHTML(el, binding);
      },
      componentUpdated(el, binding) {
        if (binding.value === binding.oldValue) return;
        setInnerHTML(el, binding);
      }
    });
  }
};
